const middleware = {}

middleware['cookieBot'] = require('../middleware/cookieBot.js')
middleware['cookieBot'] = middleware['cookieBot'].default || middleware['cookieBot']

middleware['fbclidRedirect'] = require('../middleware/fbclidRedirect.js')
middleware['fbclidRedirect'] = middleware['fbclidRedirect'].default || middleware['fbclidRedirect']

middleware['gtm'] = require('../middleware/gtm.js')
middleware['gtm'] = middleware['gtm'].default || middleware['gtm']

middleware['lowerCaseUrl'] = require('../middleware/lowerCaseUrl.js')
middleware['lowerCaseUrl'] = middleware['lowerCaseUrl'].default || middleware['lowerCaseUrl']

middleware['trailingSlashForce'] = require('../middleware/trailingSlashForce.js')
middleware['trailingSlashForce'] = middleware['trailingSlashForce'].default || middleware['trailingSlashForce']

middleware['trailingSlashRemove'] = require('../middleware/trailingSlashRemove.js')
middleware['trailingSlashRemove'] = middleware['trailingSlashRemove'].default || middleware['trailingSlashRemove']

export default middleware
